<template>
  <div v-if="false">
    <div class="box">
      <el-checkbox v-model="checked"></el-checkbox>
      <span class="gray12Span">阅读并接受</span>
      <span class="href" @click="toHref">《用户保护协议》</span>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      checked: false
    };
  },
  watch:{
    checked(){
      this.$emit('input', this.checked);
    }
  },
  methods:{
    toHref(){

    }
  }
}
</script>

<style scoped lang="scss">
.box{
  margin: 15px 0 ;
}
.href{
  cursor: pointer;
  color: $mainColor;
}
</style>
